<app-menu>
  <!-- <ng-container *ngIf="isCustomDetailsOpen">
      <app-contact-details
      (tabSelectionChange)="handleTabSelectionChange($event)"></app-contact-details>
    </ng-container> -->
  <div class="grid-header">
    <div class="grid-title">
      &nbsp;<i style="font-size: 30px;" class="fa-solid fa-truck"></i>&nbsp;&nbsp;Shipments List
    </div>
  </div>
  <mat-card>
    <mat-card-content>
      <div [formGroup]="searchShipment" style="display: flex ; justify-content: flex-start; gap: 40px;">
        <span style="flex-basis: 22%;">
          <mat-form-field style="width: 100%;">
            <mat-label>ASN Number</mat-label>
            <mat-select formControlName="asn_number" (selectionChange)="asnNumberChange($event)" required>
              <mat-option *ngFor="let type of listOfASNNumber" [value]="type">{{type}}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span style="flex-basis: 22%;">
          <mat-form-field style="width: 100%;">
            <mat-label>Trip Number</mat-label>
            <mat-select formControlName="trip_number" (selectionChange)="tripNumberChange($event)" required>
              <mat-option *ngFor="let type of listOfTripNumber" [value]="type">{{type}}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span style="flex-basis: 22%;">
          <mat-form-field style="width: 100%;">
            <mat-label>Store Number</mat-label>
            <mat-select formControlName="store_number" (selectionChange)="storeNumberChange($event)" required>
              <mat-option *ngFor="let type of listOfStoreNumber" [value]="type">{{type}}</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
      </div>
      <div style="width: 20%; display: flex; justify-content: flex-start; gap: 20px;">
        <button (click)="search()" mat-raised-button color="primary"><i class="fa-solid fa-magnifying-glass"></i><span
            style="padding: 10px 5px;"></span>Search</button>
        <button (click)="resetSearch()" mat-raised-button><i class="fa-solid fa-xmark"></i><span
            style="padding: 10px 5px;"></span>Reset</button>
      </div>
    </mat-card-content>
  </mat-card> 
  <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-alpine" [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef" [animateRows]="true" [rowData]="rowData" [rowModelType]="'serverSide'"
    [cacheBlockSize]="100" [maxBlocksInCache]="10" [masterDetail]="true" [detailRowHeight]="detailRowHeight"
    [detailCellRenderer]="detailCellRenderer" (gridReady)="onGridReady($event)" #agGrid>
  </ag-grid-angular>
</app-menu>